export const filesMigrationFolderName = '«Telegram»';
export const filesMigrationFolderId = `/${filesMigrationFolderName}`;

export const closeFilesMigrationStatusKey = 'close-files-migration-status-key';

export const CLOUD_FILES_MIGRATION_PAY_SOURCE = 'telegram_migration';
